/**
 * @generated SignedSource<<441dced64e517b7400300999ab245501>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TimelineEntryTypeEnum = "education" | "work";
import { FragmentRefs } from "relay-runtime";
export type TimelineEntriesField_TimelineEntries$data = ReadonlyArray<{
  readonly company: {
    readonly custom: boolean;
  } | null | undefined;
  readonly dateEnd: string | null | undefined;
  readonly dateStart: string | null | undefined;
  readonly description: string | null | undefined;
  readonly entryType: TimelineEntryTypeEnum | null | undefined;
  readonly id: string;
  readonly institute: {
    readonly rankingYear: number | null | undefined;
    readonly worldRankRange: string | null | undefined;
  } | null | undefined;
  readonly place: string | null | undefined;
  readonly skills: ReadonlyArray<{
    readonly id: string;
    readonly name: string;
  }> | null | undefined;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "TimelineEntriesField_TimelineEntries";
}>;
export type TimelineEntriesField_TimelineEntries$key = ReadonlyArray<{
  readonly " $data"?: TimelineEntriesField_TimelineEntries$data;
  readonly " $fragmentSpreads": FragmentRefs<"TimelineEntriesField_TimelineEntries">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TimelineEntriesField_TimelineEntries",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entryType",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "place",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateStart",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dateEnd",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Institute",
      "kind": "LinkedField",
      "name": "institute",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "worldRankRange",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "rankingYear",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "custom",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Skill",
      "kind": "LinkedField",
      "name": "skills",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TimelineEntry",
  "abstractKey": null
};
})();

(node as any).hash = "b7b5a72735844c546a5b7e73477f3d8f";

export default node;
